import { useQuery } from '@tanstack/react-query'
import { getNotifications } from 'services/notifications'

const useNotifications = () => {
  const { data: notifications, isPending: notificationsLoading } = useQuery({
    queryKey: ['getNotifications'],
    queryFn: () => getNotifications(),
  })

  return {
    notifications,
    notificationsLoading,
  }
}

export { useNotifications }
